export const initialVatsState = {
  vatsInfo: [],
};

export type TVat = {
  id?: string,
  rate?: string,
  validFrom?: string,
  validTo?: string,
}

export interface IVatsState {
  vatsInfo: TVat[]
}
